import { PROPOSAL_FIELD_LABELS } from "../model/administrationConstants";
import { displayMergeValue, formatDateTime, formatPatientName } from "../model/administrationRules";
import {
    primaryButtonStyle,
    proposalActionsStyle,
    proposalCardStyle,
    proposalCountStyle,
    proposalHeaderStyle,
    proposalMetaStyle,
    proposalPanelStyle,
    proposalValuesStyle,
    secondaryButtonStyle,
} from "../styles/administrationModalStyles";

export function AdministrativeProposalsPanel({ proposals, loading, busyIds, onAccept, onReject }) {
    if (loading && proposals.length === 0) {
        return (
            <section style={proposalPanelStyle}>
                <strong>Modifications EHPAD à valider</strong>
                <span style={{ color: "#64748b", fontSize: "13px" }}>Chargement…</span>
            </section>
        );
    }
    if (proposals.length === 0) return null;

    return (
        <section style={proposalPanelStyle}>
            <div style={proposalHeaderStyle}>
                <div>
                    <h2 style={{ margin: 0, fontSize: "17px", color: "#0f172a" }}>Modifications EHPAD à valider</h2>
                    <p style={{ margin: "4px 0 0", color: "#64748b", fontSize: "13px" }}>
                        Ces valeurs ne font pas foi tant que la pharmacie ne les a pas acceptées.
                    </p>
                </div>
                <span style={proposalCountStyle}>{proposals.length}</span>
            </div>
            <div style={{ display: "grid", gap: "10px" }}>
                {proposals.map(proposal => {
                    const busy = Boolean(busyIds[proposal.id]);
                    return (
                        <article key={proposal.id} style={proposalCardStyle}>
                            <div style={{ minWidth: 0 }}>
                                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
                                    <strong style={{ color: "#111827" }}>
                                        {formatPatientName({
                                            nom: proposal.patientNom,
                                            prenom: proposal.patientPrenom,
                                        })}
                                    </strong>
                                    {proposal.chambre && <span style={proposalMetaStyle}>Chambre {proposal.chambre}</span>}
                                    <span style={proposalMetaStyle}>{PROPOSAL_FIELD_LABELS[proposal.fieldName] || proposal.fieldName}</span>
                                </div>
                                <div style={proposalValuesStyle}>
                                    <span><strong>Avant :</strong> {displayMergeValue(proposal.oldValue)}</span>
                                    <span><strong>Actuel :</strong> {displayMergeValue(proposal.currentValue)}</span>
                                    <span><strong>Proposé :</strong> {displayMergeValue(proposal.proposedValue)}</span>
                                </div>
                                <div style={{ marginTop: "6px", color: "#64748b", fontSize: "12px" }}>
                                    Demandé par {proposal.authorName || "EHPAD"} · {formatDateTime(proposal.createdAt)}
                                    {proposal.motif && <> · Motif : {proposal.motif}</>}
                                </div>
                            </div>
                            <div style={proposalActionsStyle}>
                                <button type="button" disabled={busy} onClick={() => onAccept(proposal)} style={primaryButtonStyle}>
                                    Accepter
                                </button>
                                <button type="button" disabled={busy} onClick={() => onReject(proposal)} style={secondaryButtonStyle}>
                                    Refuser
                                </button>
                            </div>
                        </article>
                    );
                })}
            </div>
        </section>
    );
}
